import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import RumTypeService from "../services/rumTypeService";

// Add RumType Start
const defaultRumTypeState = {
  addRumTypeLoading: false,
  addRumTypeData: null,
  addRumTypeError: null,
};

const addRumTypeData = createAsyncThunk(
  "rumType/add",
  async (payload) => {
    return await RumTypeService.createRumType(payload);
  },
);

const addRumTypeReducer = createSlice({
  name: "addRumTypeData",
  initialState: defaultRumTypeState,
  extraReducers: (builder) => {
    builder.addCase(addRumTypeData.pending, (state) => {
      state.addRumTypeLoading = true;
    });
    builder.addCase(addRumTypeData.fulfilled, (state, action) => {
      state.addRumTypeLoading = false;
      state.addRumTypeData = action.payload;
      state.addRumTypeError = "";
    });
    builder.addCase(addRumTypeData.rejected, (state, action) => {
      state.addRumTypeLoading = false;
      state.addRumTypeData = null;
      state.addRumTypeError = action.error.message;
    });
  },
});

export const AddRumTypeReducer = addRumTypeReducer.reducer;
export const AddRumTypeData = addRumTypeData;
// Add RumType End

// Update RumType Start
const updateRumTypeState = {
  updateRumTypeLoading: false,
  updateRumTypeData: null,
  updateRumTypeError: null,
};

const updateRumType = createAsyncThunk(
  "rumType/update",
  async (payload) => {
    return await RumTypeService.updateRumType(payload?.rumTypeID, payload?.payload);
  },
);

const updateRumTypeReducer = createSlice({
  name: "updateRumTypeReducer",
  initialState: updateRumTypeState,
  extraReducers: (builder) => {
    builder.addCase(updateRumType.pending, (state) => {
      state.updateRumTypeLoading = true;
    });
    builder.addCase(updateRumType.fulfilled, (state, action) => {
      state.updateRumTypeLoading = false;
      state.updateRumTypeData = action.payload;
      state.updateRumTypeError = "";
    });
    builder.addCase(updateRumType.rejected, (state, action) => {
      state.updateRumTypeLoading = false;
      state.updateRumTypeData = null;
      state.updateRumTypeError = action.error.message;
    });
  },
});

export const UpdateRumTypeReducer = updateRumTypeReducer.reducer;
export const UpdateRumType = updateRumType;
//Update RumType End

// Get RumType Data List Start
const defaultRumTypeListData = {
  getRumTypeListLoading: false,
  getRumTypeListData: null,
  getRumTypeListError: null,
};

const fetchRumTypeList = createAsyncThunk(
  "rumType/rumTypeList",
  async (payload) => {
    return await RumTypeService.getRumTypeList(payload);
  },
);

const getRumTypeListReducer = createSlice({
  name: "getRumTypeListData",
  initialState: defaultRumTypeListData,
  extraReducers: (builder) => {
    builder.addCase(fetchRumTypeList.pending, (state) => {
      state.getRumTypeListLoading = true;
    });
    builder.addCase(fetchRumTypeList.fulfilled, (state, action) => {
      state.getRumTypeListLoading = false;
      state.getRumTypeListData = action.payload;
      state.getRumTypeListError = "";
    });
    builder.addCase(fetchRumTypeList.rejected, (state, action) => {
      state.getRumTypeListLoading = false;
      state.getRumTypeListData = null;
      state.getRumTypeListError = action.error.message;
    });
  },
});

export const GetRumTypeListReducer = getRumTypeListReducer.reducer;
export const FetchRumTypeList = fetchRumTypeList;
// Get RumType Data List End


// Delete RumType Start
const defaultDeleteRumTypeState = {
  deleteRumTypeLoading: false,
  deleteRumTypeData: null,
  deleteRumTypeError: null,
};

const deleteRumTypeData = createAsyncThunk(
  "rumType/delete",
  async (rumTypeID) => {
    return await RumTypeService.deleteRumType(rumTypeID);
  },
);

const deleteRumTypeReducer = createSlice({
  name: "deleteRumTypeData",
  initialState: defaultDeleteRumTypeState,
  extraReducers: (builder) => {
    builder.addCase(deleteRumTypeData.pending, (state) => {
      state.deleteRumTypeLoading = true;
    });
    builder.addCase(deleteRumTypeData.fulfilled, (state, action) => {
      state.deleteRumTypeLoading = false;
      state.deleteRumTypeData = action.payload;
      state.deleteRumTypeError = "";
    });
    builder.addCase(deleteRumTypeData.rejected, (state, action) => {
      state.deleteRumTypeLoading = false;
      state.deleteRumTypeData = null;
      state.deleteRumTypeError = action.error.message;
    });
  },
});

export const DeleteRumTypeReducer = deleteRumTypeReducer.reducer;
export const DeleteRumTypeData = deleteRumTypeData;
// Delete RumType End
